import classNames from 'clsx';
import React from 'react';

import { separator } from './Separator.scss';

const Separator: React.FC<{ customClass?: string }> = ({ customClass }) => (
  <div className={classNames(customClass, separator)} />
);

export default Separator;
